import { render, staticRenderFns } from "./PointsRecordModal.vue?vue&type=template&id=72717b24&scoped=true"
import script from "./PointsRecordModal.vue?vue&type=script&lang=js"
export * from "./PointsRecordModal.vue?vue&type=script&lang=js"
import style0 from "./PointsRecordModal.vue?vue&type=style&index=0&id=72717b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72717b24",
  null
  
)

export default component.exports